import type React from 'react'

import ChatPageContent from '../ChatPageContent'

export type TripChatDesktopSurfaceProps = React.ComponentProps<typeof ChatPageContent>

function TripChatDesktopSurface(props: TripChatDesktopSurfaceProps) {
  return <ChatPageContent {...props} />
}

export default TripChatDesktopSurface
